import React from "react";
import useResponsive from "../../core/hooks/useResponsive";
import ThreeColumn from "../../core/layouts/ThreeColumn";
import { ThreeRow, TwoRow } from "../../core/layouts";
import Styles from "./AddUserManagementFormLayout.module.scss";
import variables from "../../themes/base/styles/variables";

const AddUserFormLayoutStyle = {
  bottomSectionStyle: {
    marginTop: variables.marginMedium,
  },
  containerStyles: {
    flex: variables.flex1,
  },
  containerWrapperStyles: {
    overflow: variables.overflowUnset,
  },
};

const AddUserManagementFormLayout = ({
  leftSection,
  leftSectionStyle,
  middleSection,
  middleSectionStyle,
  rightSection,
  rightSectionStyle,
  headerTopSection,
}) => {
  const responsive = useResponsive();

  return (
    <TwoRow
      topSection={headerTopSection}
      style={AddUserFormLayoutStyle.containerWrapperStyles}
      bottomSection={
        responsive.isSm ? (
          <ThreeColumn
            style={AddUserFormLayoutStyle.containerWrapperStyles}
            className={Styles["main-details-wrapper-container"]}
            leftSection={leftSection}
            leftSectionStyle={{ width: "calc(33% - 0.75rem)" }}
            middleSection={middleSection}
            middleSectionStyle={AddUserFormLayoutStyle.containerStyles}
            rightSection={rightSection}
            rightSectionStyle={AddUserFormLayoutStyle.containerStyles}
          />
        ) : (
          <ThreeRow
            style={AddUserFormLayoutStyle.containerWrapperStyles}
            className={Styles["main-details-wrapper-container-mobile"]}
            topSection={leftSection}
            topSectionStyle={leftSectionStyle}
            middleSection={middleSection}
            bottomSection={rightSection}
            bottomSectionStyle={rightSectionStyle}
            middleSectionStyle={middleSectionStyle}
          />
        )
      }
      bottomSectionStyle={AddUserFormLayoutStyle.bottomSectionStyle}
    />
  );
};

export default AddUserManagementFormLayout;
